export default function strEllipsis(content, len) {
  if (!content) {
    return content;
  }
  if (content.length > len) {
    content = content.substring(0, len) + "...";
  }

  return content;
}
